/**
 * Winwin — browser notifications while this site is open
 * (bid placed / outbid / won). No service worker or server push.
 */
(function (global) {
  var PREF_KEY = 'ww_browser_notify';
  var ALERT_KEY = 'ww_bid_alerted';

  function supported() {
    return typeof Notification !== 'undefined';
  }

  function prefOn() {
    try {
      return localStorage.getItem(PREF_KEY) !== '0';
    } catch (e) {
      return true;
    }
  }

  function setPref(on) {
    try {
      localStorage.setItem(PREF_KEY, on ? '1' : '0');
    } catch (e) { /* ignore */ }
  }

  function enabled() {
    return supported() && Notification.permission === 'granted' && prefOn();
  }

  function readAlerted() {
    try {
      var raw = sessionStorage.getItem(ALERT_KEY);
      var map = raw ? JSON.parse(raw) : {};
      return map && typeof map === 'object' ? map : {};
    } catch (e) {
      return {};
    }
  }

  function writeAlerted(map) {
    try {
      sessionStorage.setItem(ALERT_KEY, JSON.stringify(map || {}));
    } catch (e) { /* ignore */ }
  }

  function once(tag) {
    var map = readAlerted();
    if (map[tag]) return false;
    map[tag] = true;
    writeAlerted(map);
    return true;
  }

  function requestPermission() {
    if (!supported()) return Promise.resolve('unsupported');
    if (Notification.permission === 'granted' || Notification.permission === 'denied') {
      return Promise.resolve(Notification.permission);
    }
    return Notification.requestPermission();
  }

  function show(title, body, tag) {
    if (!enabled()) return false;
    var key = tag || (title + ':' + body);
    if (!once(key)) return false;
    try {
      new Notification(title || 'Winwin Genève', {
        body: body || '',
        tag: tag || 'ww-bid',
        renotify: true
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  async function enable() {
    if (!supported()) return { ok: false, reason: 'unsupported' };
    var permission = await requestPermission();
    if (permission !== 'granted') {
      return { ok: false, reason: permission === 'denied' ? 'denied' : 'default' };
    }
    setPref(true);
    return { ok: true, enabled: true };
  }

  function disable() {
    setPref(false);
    return { ok: true, enabled: false };
  }

  function status() {
    if (!supported()) {
      return { enabled: false, permission: 'unsupported' };
    }
    return {
      enabled: enabled(),
      permission: Notification.permission
    };
  }

  function money(lot, amount) {
    var cur = 'CHF';
    if (lot && lot.currency) {
      cur = (lot.currency.symbol || lot.currency) || 'CHF';
      if (typeof cur === 'object') cur = cur.symbol || 'CHF';
    }
    if (amount == null || amount === '') return cur;
    var raw = String(amount).trim();
    if (/^(CHF|EUR|USD|GBP|£|€)\b/i.test(raw)) return raw;
    return cur + ' ' + raw;
  }

  function lotLabel(lot) {
    if (!lot) return 'Lot';
    return lot.name || lot.lot_name || ('Lot ' + (lot.lot_number || ''));
  }

  function lotKey(lot) {
    if (!lot) return '';
    return String(lot.idcatalogue || '') + ':' + String(lot.lot_number || lot.idlot || '');
  }

  function isHighest(lot) {
    return !!(lot && (lot.is_highest_bidder == 1 || lot.is_highest_bidder === true));
  }

  function isWinning(lot) {
    return !!(lot && (lot.is_winning_bidder == 1 || lot.is_winning_bidder === true));
  }

  function notifyBidPlaced(lot, amount) {
    var label = lotLabel(lot);
    var amt = money(lot, amount != null ? amount : (lot && lot.current_bid));
    return show(
      'Bid placed',
      'Your bid of ' + amt + ' on ' + label + ' has been placed.',
      'ww-bid-placed-' + lotKey(lot) + '-' + String(amount || '')
    );
  }

  /** Compare previous vs next lot snapshot (lot page poll). opts.ended = bidding closed. */
  function onLotUpdate(prev, next, opts) {
    if (!next || !enabled()) return;
    var key = lotKey(next);
    if (!key) return;
    opts = opts || {};

    var wasHighest = isHighest(prev);
    var nowHighest = isHighest(next);
    var nowWinning = isWinning(next);
    var label = lotLabel(next);
    var ended = !!opts.ended;
    var wasEnded = !!opts.wasEnded;

    if (wasHighest && !nowHighest && !ended) {
      show(
        "You've been outbid",
        label + ' — current bid is now ' + money(next, next.current_bid) + '.',
        'ww-outbid-' + key + '-' + String(next.current_bid || '')
      );
    }

    if (ended && !wasEnded && (nowWinning || nowHighest)) {
      show(
        'You won',
        'Congratulations — you won ' + label + '.',
        'ww-won-' + key
      );
    }
  }

  async function maybePromptAfterBid() {
    if (!supported() || Notification.permission === 'denied') return;
    if (Notification.permission === 'granted') {
      setPref(true);
      return;
    }
    try {
      if (sessionStorage.getItem('ww_notify_asked') === '1') return;
      sessionStorage.setItem('ww_notify_asked', '1');
    } catch (e) { /* ignore */ }
    await enable();
  }

  global.WinwinPush = {
    supported: supported,
    enable: enable,
    disable: disable,
    status: status,
    show: show,
    notifyBidPlaced: notifyBidPlaced,
    onLotUpdate: onLotUpdate,
    maybePromptAfterBid: maybePromptAfterBid
  };
})(window);
